import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import Styles from './grouppolicyStyle.module.scss';
import ProgressBar from '../../components/ProgressBar/progressbar';
import CreateGroupForm from './CreateGroupForm';
import { ToastProvider } from '../../providers/ToastProvider/ToastContext';

const CreateGroup = () => {
  const navigate = useNavigate();

  return (
    <ToastProvider>
      <div className="flex">
        <Sidebar></Sidebar>
        <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
          <Header title="Group Policy" dropdown={2} />

          <Card className="flex-1">
            <div className={`${Styles.progressBar} items-center justify-between mb-0`}>
              <ProgressBar stepNum={1} identity={'Create Group'} />
            </div>
            <CreateGroupForm />
          </Card>
        </div>
      </div>
    </ToastProvider>
  );
};

export default CreateGroup;
